import { Amplify } from 'aws-amplify';
import { getEnvironment, getApiBaseUrl, getCognitoConfig } from '@/config/domains';

const environment = getEnvironment();
const cognitoConfig = getCognitoConfig();

console.log('AWS Config - Environment detected:', environment);
console.log('AWS Config - Cognito config:', cognitoConfig);

const awsConfig = {
  Auth: {
    Cognito: {
      ...cognitoConfig,
      signUpVerificationMethod: 'code' as const,
      loginWith: {
        email: true,
        username: false,
      },
    },
  },
  API: {
    REST: {
      'VodShoppableAdsAPI': {
        endpoint: getApiBaseUrl(),
        region: 'eu-west-1',
      },
    },
  },
};

// Configure Amplify
Amplify.configure(awsConfig);

export default awsConfig;
